import { useLocation, useNavigate } from 'react-router-dom';

function AdminHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const pageTitle = location.pathname.split('/').pop() || 'Dashboard';
  
  const getTitle = () => {
    const titles: { [key: string]: string } = {
      'admin': 'Dashboard',
      'dashboard': 'Dashboard',
      'produtos': 'Produtos',
      'pedidos': 'Pedidos',
      'categorias': 'Categorias',
      'promocoes': 'Promoções',
    };
    return titles[pageTitle] || 'Dashboard';
  };

  const showBackButton = pageTitle !== 'admin' && pageTitle !== 'dashboard';
  const showAddButton = pageTitle === 'produtos' || pageTitle === 'categorias' || pageTitle === 'promocoes';

  const handleAddClick = () => {
    if (pageTitle === 'produtos') {
      navigate('/admin/produtos?new=true', { replace: false });
    } else if (pageTitle === 'categorias') {
      navigate('/admin/categorias?new=true', { replace: false });
    } else if (pageTitle === 'promocoes') {
      navigate('/admin/promocoes?new=true', { replace: false });
    }
  };

  return (
    <header className="mobile-header">
      {showBackButton ? (
        <button 
          className="back-btn" 
          aria-label="Voltar"
          onClick={() => navigate('/admin')}
        >
          <i className="fas fa-arrow-left"></i>
        </button>
      ) : (
        <button className="menu-btn" aria-label="Menu">
          <i className="fas fa-bars"></i>
        </button>
      )}
      <h1 className="header-title">{getTitle()}</h1>
      {showAddButton ? (
        <button className="add-btn" aria-label="Adicionar" onClick={handleAddClick}>
          <i className="fas fa-plus"></i>
        </button>
      ) : (
        <button className="user-btn" aria-label="Usuário">
          <i className="fas fa-user"></i>
        </button>
      )}
    </header>
  );
}

export default AdminHeader;

